
import Component, { mixins } from 'vue-class-component';
import { Member } from '@/models/member';
import { GroupScope } from '@/components/mixins/groupscope';
import { getPercentComplete } from '@/services/utils';
import { GroupSchemeScope } from '@/components/mixins/schemescope';
import GroupedMemberView from '@/components/common/GroupedMemberView.vue';

@Component({
  name: 'AssessByMemberMenu',
  components: {
    GroupedMemberView,
  },
})
export default class AssessByMemberMenu extends mixins(GroupScope, GroupSchemeScope) {
  /**
   * search
   * Current value of the search string.
   *
   * @property {string}
   */
  private search = '';

  /**
   * Created hook, runs before component is mounted.
   * Makes sure the relevant group information is fetched from the IDB/API for this and nested pages.
   *
   * @return {void}
   */
  created(): void {
    this.loadGroup();
  }

  /**
   * Returns the index's of assess by member panels.
   *
   * @return {Array<number>}
   */
  get openPanels(): Array<number> {
    return this.$store.getters['groups/getAssessByMemberOpenPanelList'];
  }

  /**
   * Returns the members for this group.
   *
   * @return {Array<Member>}
   */
  get records(): Array<Member> {
    return this.groupMembers.filter((record: Member) => record.in);
  }

  /**
   * Formats each members name suitable for URL display, it is then attached to that members link as a param.
   *
   * @param {Member} member
   * @return {string}
   */
  getMemberLinkName(member: Member): string {
    // Encoding may be overkill but #whateverbesafe
    return encodeURIComponent(member.firstname.toLowerCase() + '-' + member.lastname.toLowerCase());
  }

  getPercentageComplete(member: Member): string {
    if (this.group && this.group.levels && this.group.levels.length > 0) {
      const levels = this.getMemberActiveLevels(member);
      const nodes = levels.map(this.getNode);
      return getPercentComplete(nodes, member.scores, this.schemeGrades);
    }
    return '0%';
  }

  get showPercentageComplete(): boolean {
    return this.$store.getters['auth/isFeatureEnabled']('SHOW_PERCENTAGE_COMPLETE');
  }

  /**
   * Returns the groups members filtered on first and last name by the components search string property.
   *
   * @return {Array<Member>}
   */
  get filteredRecords(): Array<Member> {
    return this.records.filter((member: Member) => {
      if (!this.search) {
        return this.records;
      }
      return (
        member.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
        member.lastname.toLowerCase().includes(this.search.toLowerCase())
      );
    });
  }
}
